import { Tooltip } from 'antd';
import type { ComponentProps } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomiseColumnsIconButton } from './customiseColumnsToolbar';

type CustomiseColumnsIconButtonProps = ComponentProps<
  typeof CustomiseColumnsIconButton
>;

type Props = CustomiseColumnsIconButtonProps & {
  tooltipTitle?: string;
};

/** Settings cog for column customisation — consistent hover tooltip app-wide. */
export const CustomiseColumnsIconButtonWithTooltip: React.FC<Props> = ({
  tooltipTitle,
  title,
  'aria-label': ariaLabel,
  ...buttonProps
}) => {
  const { t } = useTranslation();
  const resolvedTitle =
    tooltipTitle ?? title ?? ariaLabel ?? t('main.customise-columns-tooltip');

  return (
    <Tooltip
      title={resolvedTitle}
      getPopupContainer={() => document.body}
      mouseEnterDelay={0.25}
    >
      <span
        className="customise-columns-icon-button-tooltip-target"
        style={{ display: 'inline-flex' }}
      >
        <CustomiseColumnsIconButton
          {...buttonProps}
          aria-label={ariaLabel ?? resolvedTitle}
        />
      </span>
    </Tooltip>
  );
};

export {
  CUSTOMISE_COLUMNS_ICON_COLOR,
  CUSTOMISE_COLUMNS_ICON_FONT_SIZE,
  CustomiseColumnsIconButton,
  customiseColumnsIconButtonStyle,
} from './customiseColumnsToolbar';
